import { render } from "./LocationNotAllowed.vue?vue&type=template&id=6440b11f"
import script from "./LocationNotAllowed.vue?vue&type=script&lang=js"
export * from "./LocationNotAllowed.vue?vue&type=script&lang=js"

import "./LocationNotAllowed.vue?vue&type=style&index=0&id=6440b11f&media=screen&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__